// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-01783691]:export{primaryColor:#64b5f6;secondaryColor:#003c60;accentColor:#c41230}.magenta-fill[data-v-01783691]{fill:#f0f!important}.magenta-text[data-v-01783691]{color:#f0f!important}", ""]);
// Exports
module.exports = exports;
